import { LitElement, html } from 'lit-all'

class ASDisplayCount extends LitElement {
  static properties = {
    _totalProducts: { type: Number, state: true },
    _perPage: { type: Number, state: true },
    _page: { type: Number, state: true },
  }

  get _endRange() {
    return this._perPage > this._totalProducts
      ? this._totalProducts
      : this._perPage;
  }

  get _rangeStart() {
    return (this._perPage * this._page) - this._perPage + 1
  }

  get _range() {
    return this._perPage > this._totalProducts ?
      `1 - ${this._totalProducts}` :
      `${this._rangeStart} - ${this._perPage * this._page}`

  }

  constructor() {
    super()

    this._totalProducts = 0
    this._perPage = 0
    this._page = 1
  }

  connectedCallback() {
    super.connectedCallback()
    const productGrid = document.querySelector('as-product-grid')
    
    document.addEventListener('case-finder:display-count', this._updateCount)

    productGrid._updateDisplayCount()
  }

  disconnectedCallback() {
    super.connectedCallback()

    document.removeEventListener('case-finder:display-count', this._updateCount)
  }

  _updateCount = ({ detail }) => {
    this._totalProducts = detail.totalProducts
    this._perPage = Number(detail.perPage)
    this._page = Number(detail.page)
  }

  render() {
    return this._totalProducts === 0 
      ? html`<span>Showing 0 products</span>`
      : html`<span>Showing ${this._range} of ${this._totalProducts} products</span>`
  }
}

customElements.define('as-display-count', ASDisplayCount)